export default __webpack_public_path__ + "static/IDMC_GRID_2022 Un primer vistazo-Desplazamientos internos en 2021-e5d2e86cdf999e53721333b161be261c.jpg";